var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          staticClass: "modal-edit-deliverable",
          attrs: {
            size: "xl",
            "hide-footer": "",
            id: "editDeliverableModal",
            title: ""
          },
          on: { hide: _vm.editDeliverableModalHidden }
        },
        [
          _c("EditModal", {
            ref: "refEditModal",
            attrs: { allContacts: _vm.allContacts, namespace: _vm.namespace }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "modal-edit-project",
          attrs: {
            size: "xl",
            "hide-footer": "",
            id: "editProjectModal",
            title: ""
          },
          on: { hide: _vm.editProjectModalHidden }
        },
        [_c("EditProjectModal", { ref: "refEditProjectModal" })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "modal-edit-social-deliverable",
          attrs: {
            size: "lg",
            "hide-footer": "",
            id: "editSocialModal",
            title: "Edit Social Deliverable",
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          },
          on: {
            show: _vm.editSocialModalShown,
            shown: _vm.afterEditSocialModalShown,
            hide: _vm.editSocialModalHidden
          }
        },
        [
          _c("EditSocialModal", {
            ref: "refEditSocialModal",
            attrs: {
              allContacts: _vm.allContacts,
              tabIndex: _vm.tabIndex,
              namespace: _vm.namespace
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "modal-edit-deliverable",
          attrs: {
            size: "xl",
            "no-close-on-backdrop": "",
            "no-close-on-esc": "",
            "hide-footer": "",
            id: "editOrganicSocialMediaPlanModal",
            title: "Edit Organic Social Media Plan"
          },
          on: { hide: _vm.editOrganicSocialModalPlanHidden }
        },
        [
          _c("EditOrganicSocialMediaPlanModal", {
            ref: "refEditOrganicSocialMediaPlanModal",
            attrs: { tabIndex: _vm.tabIndex, namespace: _vm.namespace }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("HeaderControls", {
        attrs: { myWeek: false, namespace: _vm.namespace },
        on: {
          filterUpdated: _vm.filterUpdate,
          collapseToggleUpdated: _vm.collapseToggleUpdate
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container-fluid" },
        [
          _c("CalendarView", {
            attrs: {
              filterQuery: _vm.filterQuery,
              namespace: _vm.namespace,
              initialView: _vm.initialView,
              initialDate: _vm.initialDate
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }